export function readCookie(name: string) {
  const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'))
  return (match ? decodeURIComponent(match[3]) : '')
}
